import { useState, useRef } from 'react';

import { Cell, CellText, Link, Drop } from '@hh.ru/magritte-ui';
import { ChevronUpDownOutlinedSize16, CheckOutlinedSize16 } from '@hh.ru/magritte-ui/icon';
import { TranslatedComponent } from 'bloko/common/hooks/useTranslations';

import translation from 'src/components/translation';
import { useSelector } from 'src/hooks/useSelector';
import { SearchPeriodOption } from 'src/types/search/vacancy/criteria';

import useChangeSearchPeriod from 'src/components/SearchSorts/hooks/useChangeSearchPeriod';

const TrlKeys = {
    [SearchPeriodOption.AllTime]: 'search.period.0',
    [SearchPeriodOption.Month]: 'search.period.30',
    [SearchPeriodOption.Week]: 'search.period.7',
    [SearchPeriodOption.ThreeDays]: 'search.period.3',
    [SearchPeriodOption.Day]: 'search.period.1',
};

const SearchPeriod: TranslatedComponent = ({ trls }) => {
    const options = useSelector((state) => state.vacancySearchDictionaries.searchPeriod);
    const value = useSelector((state) => state.vacancySearchResult.criteria?.search_period);
    const formattedValue = (value?.toString() as SearchPeriodOption) || SearchPeriodOption.AllTime;
    const handleChange = useChangeSearchPeriod();

    const [isDropVisible, setDropVisible] = useState(false);
    const selectorHost = useRef(null);

    if (!options) {
        return null;
    }

    return (
        <>
            <Drop
                visible={isDropVisible}
                activatorRef={selectorHost}
                onClose={() => setDropVisible(false)}
                placement="bottom-left"
                forcePlacement
                data-qa="search-period-menu-drop"
            >
                {options.map((option) => (
                    <Cell
                        key={option}
                        vertPadding
                        horPadding
                        roundedBorder
                        onClick={() => {
                            setDropVisible(false);
                            if (option !== formattedValue) {
                                handleChange(option);
                            }
                        }}
                        data-qa={`order-by-${option}`}
                        right={formattedValue === option ? <CheckOutlinedSize16 initialColor="accent" /> : undefined}
                    >
                        <CellText>{trls[TrlKeys[option]]}</CellText>
                    </Cell>
                ))}
            </Drop>
            <Link
                onClick={() => setDropVisible(!isDropVisible)}
                iconRight={<ChevronUpDownOutlinedSize16 />}
                ref={selectorHost}
                data-qa="search-period-menu"
            >
                {trls[TrlKeys[formattedValue]]}
            </Link>
        </>
    );
};

export default translation(SearchPeriod);
